import React, { useEffect, useState } from "react";
import {
  Nav, NavItem, TabContent, NavLink, TabPane
} from "reactstrap";
import styles from "./style.module.scss";
import cx from "classnames";
import { Animated } from "react-animated-css";

const AnimatedTabs = props => {
  const { tabsLabels = [] } = props;
  const [currentActiveTab, setCurrentActiveTab] = useState(1);

  useEffect(() => {
  }, []);

  const toggleTab = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  }

  const getTabsLabels = () => {
    return tabsLabels.map((label, index) => {
      const tabIndex = index + 1;
      return (
        <NavItem key={tabIndex}>
          <NavLink
            className={cx({
              [styles.tabLink]: currentActiveTab !== tabIndex,
              [styles.tabActive]: currentActiveTab === tabIndex
            })}
            onClick={(e) => toggleTab(tabIndex)}
          >
            {label}
          </NavLink>
        </NavItem>
      );
    });
  }

  const getTabPanes = () => {
    return React.Children.map(props.children, (tp, index) => {
      const tabIndex = index + 1;
      return (
        <TabPane tabId={tabIndex}>
          <Animated
            animationIn="fadeInDown" 
            animationOut="fadeOut"
            isVisible={currentActiveTab === tabIndex}
          >
            {tp}
          </Animated>
        </TabPane>
      )
    })

  }

  return (
    <>
      <Nav tabs>
        {getTabsLabels()}
      </Nav>
      <TabContent
        className={styles.tabContent}
        activeTab={currentActiveTab}>
        {getTabPanes()}
      </TabContent>
    </>
  );
}

export default AnimatedTabs;
